// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__11RoY","content":"Consent_content__2_3fb","footer":"Consent_footer__22Clo"};